'use strict';

var App = require('app');
var CharacteristicView = require('components/devices/views/controller/characteristic_view');
var DrinkingWaterView = require('components/devices/views/controller/drinking_water_parametrization_view');
var DrinkingWaterDialogView = require('components/devices/views/controller/drinking_water_dialog_view');
var ConstantView = require('components/devices/views/controller/constant_view');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Parameter = require('models/parameter');
var ParameterDialogView = require('components/devices/views/controller/parameter_dialog_view');
var Types = require('consts').HeatCharacteristicTypes;

var ParameterView = Backbone.Marionette.LayoutView.extend({
    template: require('components/devices/templates/controller/parameter'),

    ui: {
        svg: '#js-graph',
        save: '#js-save',
        address: '#js-data-point',
        value: '#js-value',
        coilAddress: '#js-coil',
        coilValue: '#js-coil-value',
        edit: '.js-edit',
        editIcon: '.js-edit-icon',
        tab: '.js-tab',
        parameterContainer: '.js-parameter-container',
    },

    events: {
        'click @ui.save': 'save',
        'click @ui.edit': 'edit',
    },

    regions: {
        config: '#js-config',
        slope: '#js-slope',
        circuit: '#circuit-region',
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: function (view) {
                var buttons = [];
                _.each(view.options.parameter.circuits, function (circuitKey) {
                    buttons.push('button#edit-circuit-' + circuitKey);
                });
                return buttons;
            },

            getDeviceID: function (view) {
                return view.options.device.id;
            },
        },
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.device = options.device;
        this.circuitNames = options.device.getCircuitNames();
        this.forceReadonly = options.forceReadonly;
        this.smartTemp = options.smartTempInfo;

        this.setPermission(options.permissions);
        this.initParameter(options.parameter, options.inconsistent);
    },

    // checks if all present heat circuits are cold regulations
    hasOnlyColdRegulation: function (coils) {
        coils = coils || this.coils;
        var coldRegulation = _.pick(coils, [
            1028 + Consts.CircuitOffsetsCoils[10],
            1028 + Consts.CircuitOffsetsCoils[20],
            1028 + Consts.CircuitOffsetsCoils[30],
            1028 + Consts.CircuitOffsetsCoils[110],
            1028 + Consts.CircuitOffsetsCoils[120],
            1028 + Consts.CircuitOffsetsCoils[130],
        ]);

        var onlyColdRegulation = !$.isEmptyObject(coldRegulation);
        _.each(coldRegulation, function (active, key) {
            onlyColdRegulation = onlyColdRegulation && active;
        });

        return onlyColdRegulation;
    },

    initParameter: function (parameter, inconsistent, circuitID) {
        this.inconsistent = inconsistent;
        // get values
        this.register = parameter.data_points.register;
        this.coils = parameter.data_points.coils;

        if (this.hasOnlyColdRegulation()) {
            this.noCircuitsToShow = true;
            return;
        }
        this.noCircuitsToShow = false;

        // refresh specific circuit?
        //    -> keep current circuits and replace specified one
        // or -> (re)-initialize all of them
        this.heatCircuits = circuitID ? this.heatCircuits : {};
        // parse parameter for each heat circuit
        this.valuesComplete = true;
        _.each(
            parameter.circuits,
            function (circuitNr) {
                var mode =
                    this.coils[1029 + Consts.CircuitOffsetsCoils[circuitNr]] === 1 ? i18n.TR('Fußbodenheizung') : '';

                this.heatCircuits[circuitNr] = new Parameter({
                    firmware: this.device.attributes.firmware,
                    register: this.register,
                    coils: this.coils,
                    circuitNr: circuitNr,
                    name:
                        circuitNr == Consts.Circuits['WarmWater']
                            ? this.circuitNames['control-water']
                            : this.circuitNames['control-' + Math.round(circuitNr / 10)],
                    mode: mode,
                    canEdit: this.options.parameter.is_configurable[circuitNr] && !this.readOnly,
                    isInconsistent: this.isInconsistent(),
                });

                // no region for current circuit? -> add a new one
                if ($.isEmptyObject(this.getRegion('circuit' + circuitNr))) {
                    var reg = {};
                    reg['circuit' + circuitNr] = '#circuit-' + circuitNr;
                    this.addRegions(reg);
                }

                this.valuesComplete = this.valuesComplete && this.heatCircuits[circuitNr].valuesComplete;
            },
            this
        );
    },

    setPermission: function (permissions) {
        var editParameterPermission = permissions.get(Consts.Permissions.HandlingParameter);
        if (
            this.forceReadonly ||
            editParameterPermission === undefined ||
            (this.smartTemp && (this.smartTemp.isActive() || this.smartTemp.isDryRun()))
        ) {
            this.readOnly = true;
            return;
        }
        this.readOnly = editParameterPermission;
    },

    serializeData: function () {
        var errorMessage = {
            title: i18n.TR('Fehler'),
            text: i18n.TR('Nicht alle Daten für die Parametrierung konnten geladen werden.'),
            color_class: 'box-color-error',
        };
        if (this.noCircuitsToShow) {
            errorMessage = {
                title: i18n.TR('Information'),
                text: i18n.TR('Diese Anlage enthält nur Kälteregelungen. Diese werden momentan nicht unterstützt.'),
                color_class: 'box-color-info',
            };
        }
        var data = {
            readOnly: this.readOnly,
            heatCircuits: this.heatCircuits,
            circuitConfig: {
                readOnly: true,
            },
            valuesComplete: this.valuesComplete,
            errorMessage: errorMessage,
        };
        if (this.smartTemp) {
            data.warnings = this.smartTemp.getWarnings(
                i18n.TR('Die Einstellungen können nicht verändert werden, solange Smart Temp aktiv ist.')
            );
        }

        return data;
    },

    onShow: function () {
        if (this.valuesComplete) {
            this.showCircuits();
        }
    },

    // reloads the specified circuit or all, if none is specified
    reload: function (circuitID) {
        var self = this;
        // set spinner
        Decorator.displayLoading(true, '.card-box');
        App.hideModal();
        var parameter = App.request(
            'device:get:parameter',
            this.options.deviceID,
            Misc.isFirmwareSufficient(this.options.device.get('firmware'), '2.28')
        );
        var inconsistent = App.request('device:inconsistent', this.device);
        $.when(parameter, inconsistent).done(function (parameter, inconsistent) {
            Decorator.displayLoading(false, '.card-box');
            if (circuitID) {
                parameter.circuits = _.filter(parameter.circuits, function (circuitNr) {
                    return circuitNr == circuitID;
                });
            }

            self.initParameter(parameter, inconsistent, circuitID);
            if (circuitID) {
                self.showCircuit(circuitID);
            } else {
                self.showCircuits();
            }
        });
    },

    showCircuits: function () {
        _.each(
            this.heatCircuits,
            function (circuit, key) {
                this.showCircuit(key);
            },
            this
        );
    },

    showCircuit: function (circuitNr) {
        var values = this.heatCircuits[circuitNr];
        var options = { values: values, readOnly: true, circuitNr: circuitNr, device: this.device };
        var view = new CharacteristicView(options);
        if (values.getType() === Types.ConstantValue) {
            view = new ConstantView(options);
        }
        if (circuitNr == Consts.Circuits['WarmWater']) {
            view = new DrinkingWaterView(options);
        }
        this.showChildView('circuit' + circuitNr, view);
        var incon = this.isInconsistent();
        this.ui.parameterContainer.addClass(incon ? 'highlight' : 'bg-white');
        this.ui.parameterContainer.removeClass(incon ? 'bg-white' : 'highlight');
        this.ui.editIcon.addClass(incon ? 'fa fa-hourglass' : 'glyphicon-pencil');
        this.ui.editIcon.removeClass(incon ? 'glyphicon-pencil' : 'fa fa-hourglass');
    },

    isInconsistent: function () {
        if ($.isEmptyObject(this.inconsistent) || this.inconsistent.any === false) {
            return false;
        }
        return true;
    },

    edit: function (e) {
        // The modal gets messed up, when the same view is showed twice (here and in the modal) so we destroy this one
        var currentCircuit = parseInt(e.currentTarget.id.split('-')[2]);
        if (this.isInconsistent()) {
            Notification.show(
                'warning',
                i18n.TR('Warnung'),
                i18n.TR('Vorangegangener Schreibbefehl wird verarbeitet.')
            );
            this.reload(currentCircuit);
            return;
        }
        // make a deep copy of the current values so we can "pass by value"
        var values = $.extend(true, {}, this.heatCircuits[currentCircuit]);
        var activeTab = currentCircuit == 90 ? this.getChildView('circuit90').activeTab : undefined;
        var options = {
            values: values,
            circuitNr: currentCircuit,
            circuit: this.heatCircuits[currentCircuit],
            totalCircuits: Object.keys(this.heatCircuits).length,
            deviceID: this.options.deviceID,
            firmware: this.options.device.attributes.firmware,
            callback: $.proxy(this.reload, this, currentCircuit),
            readOnly: false,
            device: this.device,
            activeTab: activeTab,
        };
        var view =
            currentCircuit == Consts.Circuits['WarmWater']
                ? new DrinkingWaterDialogView(options, this.device)
                : new ParameterDialogView(options);
        App.showModal(view);
    },

    save: function () {
        var register = parseInt(this.ui.address.val());
        var value = parseInt(this.ui.value.val());
        var coil = parseInt(this.ui.coilAddress.val());
        var coilValue = '1' === this.ui.coilValue.val();
        var registerData = [{ address: register, value: value }];
        var coilData = [{ address: coil, value: coilValue }];
        App.request('device:set:parameter', this.options.deviceID, { register: registerData, coils: coilData });
    },
});

module.exports = ParameterView;
